import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function WebHeader({strikes, setShowHelp}) {
    const getStrikes = () => {
        let strikeArray = []
        for (let i = 0; i < 3; i++) {
            if (i < strikes?.length) {
                strikeArray.push(<FontAwesomeIcon icon={["fas", "times"]} size={"xl"} key={i} color="red" />)
            }
            else {
                strikeArray.push(<FontAwesomeIcon icon={["fas", "times"]} size={"xl"} key={i} color="white" />)
            }
        }
        return <div style={{display:'flex', alignItems:'flex-start', justifyContent:'center'}}>{strikeArray}</div>
    }
    return (
        <header className="App-header">
            <div style={{ display: 'flex', alignItems: 'center', width: '20%' }}>
                {getStrikes()}
            </div>
            <h1 style={{ cursor: 'default', fontWeight: 'bolder', color: 'white' }}>CineSnake</h1>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', width: '20%' }}>
                <button className='help-button-web' onClick={() => setShowHelp(true)}>Help</button>
            </div>
        </header>
    )
}